import React, { useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap';
import firebase from 'firebase'
import style from './link.module.css'
function LinkUI({ name, link1, linkid, isInEditLink }) {
    const [show, setShow] = useState(false);
    const [link, setLink] = useState(link1)
    const [nameNew, setName] = useState(name)
    const closeEditLinkModal = () => setShow(false);
    const showEditLinkModal = () => setShow(true);
    const save = () => {
        if (nameNew === name) {
            firebase.database().ref(linkid).child('links').child(name).set(link)
                .then(() => { alert("changed"); window.location.reload(); })
        }
        else if (nameNew !== name && nameNew.length > 0) {
            firebase.database().ref(linkid).child('links').child(nameNew).set(link)
                .then(() => { firebase.database().ref(linkid).child('links').child(name).set(null) })
                .then(() => { alert("changed"); window.location.reload(); })

        }
    }
    const gotoLink = () => {
        window.open(link1, '_blank')
    }
    const del = () => {
        firebase.database().ref(linkid).child('links').child(name).set(null).then(() => { alert("deleted"); window.location.reload(); })
    }
    return (
        <>
            <div className='row'>
                <div style={{ borderRadius: '10px', height: '50px' }}
                    className='d-flex align-items-center 
                     btn btn-secondary justify-content-center ml-2 mt-4 col-12 text-primary p-1 text-center '
                    onClick={() => isInEditLink ? showEditLinkModal() : gotoLink()}>
                    {name || "Name"}

                </div>
            </div >
            <Modal className={style.modalz} show={show} onHide={closeEditLinkModal}>
                <Modal.Header className='bg-secondary text-primary' closeButton>
                    <Modal.Title>{name || "name"}</Modal.Title>
                </Modal.Header>
                <Modal.Body className='bg-secondary text-primary'>
                    <Form>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Link Name:</Form.Label>
                            <Form.Control className="bg-dark text-primary col-11 m-2" value={nameNew || ""} onChange={(e) => setName(e.target.value)} />
                            <Form.Text className="text-primary">
                                Should be unique among your links
                            </Form.Text>
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword">
                            <Form.Label>Link</Form.Label>
                            <Form.Control type='url' className="bg-dark text-primary col-11 m-2" value={link || ""} onChange={(e) => setLink(e.target.value)} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className='bg-secondary text-primary'>
                    <Button className="btn btn-dark text-primary" onClick={closeEditLinkModal}>
                        Close
          </Button>
                    <Button className="btn btn-danger text-dark" variant="secondary" onClick={del}>
                        Delete Link
          </Button>
                    <Button variant="primary" onClick={save}>
                        Save Changes
          </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default LinkUI
